// Persist a stable anonymous device id in localStorage.
// Used to track free-quota usage and link to a Stripe payment.

const KEY = "smartresume.deviceId";

function uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  // RFC4122 v4 fallback
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // localStorage may be blocked — fall back to ephemeral memory id.
    if (!window.__smartResumeDeviceMemoryId) {
      window.__smartResumeDeviceMemoryId = uuid();
    }
    return window.__smartResumeDeviceMemoryId;
  }
}
